import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  FormControl,
  FormGroup,
  Validators,
  FormBuilder,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { PasswordRecoveryService } from '../../services/password-recovery.service';
import { environment } from '../../../../../environments/environment';
import { UserGraphQLService } from '../../../../graphQL/services/user/userGraphQL.service';
import { TranslatedTextPasswordRecovery } from '../../../../commons/constants/translated-text-key-password-recovery';
import * as CryptoJS from 'crypto-js';
import { ProgreesBarService } from 'src/app/commons/services/progrees-bar.service';
import { ModalService } from 'src/app/commons/services/modal.service';
import { ROUTER_LOGIN } from 'src/app/commons/constants/router/router.constant';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-password-recovery',
  templateUrl: './password-recovery.component.html',
  styleUrls: ['./password-recovery.component.scss'],
})
export class PasswordRecoveryComponent implements OnInit, OnDestroy {
  public passwordRecoveryEmailForm: FormGroup;
  private _sendEmailSubscription: Subscription;
  private _onChangeLanguage: Subscription;
  backgroundImage=environment.backgroundImage;
  public passwordToken :string="";
  translatedTextKeyPasswordRecovery = TranslatedTextPasswordRecovery;
  public passwordRecoveryForm: FormGroup;
  public isRecovery: boolean = true;
  public allowSend: boolean = false;
  constructor(
    private router: Router,
    private _fb: FormBuilder,
    private _passwordRecoveryService: PasswordRecoveryService,
    public _userService: UserGraphQLService,
    private _activatedRoute: ActivatedRoute,
    private progreesBarService: ProgreesBarService,
    public modalService: ModalService,
    private translate: TranslateService
  ) {
    this.getStoreConfig();
    this._activatedRoute.queryParams.subscribe((params) => {
      if (
        params['accestoken'] !== null &&
        params['accestoken'] !== undefined &&
        params['accestoken'] !== ''
      ) {
        this.passwordToken = params['accestoken'];

        if (
          params['type'] !== null &&
          params['type'] !== undefined &&
          params['type'] !== ''
        ) {
          this.isRecovery = false;
        }
      }
    });

    this.createForm();
    this.createFormRecovery();
  }

  getStoreConfig() {
    this.progreesBarService.showProgressBar();
    this._userService.getStoreConfig(environment.storeIdComplete).subscribe({
      next: (data: any) => {

        this._userService.storeConfig = data.getStoreInfo;
        this.progreesBarService.hideProgressBar();
        this.allowSend = true;
      },
    });
  }
  private createFormRecovery(): void {
    this.passwordRecoveryForm = this._fb.group(
      {
        password: ['', [Validators.required, this.passwordPolicyValidator]], // Política de validación personalizada
        confirmpassword: ['', [Validators.required]],
      },
      {
        validator: this.passwordMatchValidator('password', 'confirmpassword'), // Validación de coincidencia
      }
    );
    this.passwordRecoveryForm.get('password').setValue('');
    this.passwordRecoveryForm.get('confirmpassword').setValue('');
  }

passwordPolicyValidator(control: AbstractControl): ValidationErrors | null {
  const password = control.value;
  const passwordPolicy =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,12}$/;

  if (password && !passwordPolicy.test(password)) {
    return { passwordPolicy: true };
  }
  return null;
}

  // Validador para asegurar que las contraseñas coincidan
  passwordMatchValidator(password: string, confirmpassword: string) {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const passwordControl = formGroup.get(password);
      const confirmPasswordControl = formGroup.get(confirmpassword);

      if (
        confirmPasswordControl?.errors &&
        !confirmPasswordControl.errors['passwordMismatch']
      ) {
        return null;
      }

      if (passwordControl?.value !== confirmPasswordControl?.value) {
        confirmPasswordControl?.setErrors({ passwordMismatch: true });
      } else {
        confirmPasswordControl?.setErrors(null);
      }

      return null;
    };
  }

  ngOnInit(): void {
    this.onChangeLanguage();
  }

  ngOnDestroy(): void {
    this._sendEmailSubscription?.unsubscribe();
    this._onChangeLanguage?.unsubscribe();
  }

  private createForm(): void {
    this.passwordRecoveryEmailForm = this._fb.group({
      email: [{ value: '' }, [Validators.required, Validators.email]],
    });
    this.passwordRecoveryEmailForm.get('email').setValue('');
  }

  goToComponent(path: string) {
    this.router.navigate([path]);
  }

  SendRecoveryEmail() {
    if (!this.passwordRecoveryEmailForm.valid) {
      this.passwordRecoveryEmailForm.markAllAsTouched();

      return;
    }

    this.RecoveryEmail(this.passwordRecoveryEmailForm.controls['email'].value);
  }

  private RecoveryEmail(email: any): void {
    this.progreesBarService.showProgressBar();
    this._sendEmailSubscription = this._passwordRecoveryService
      .sendPasswordRecoveryEmail(
        {
          email,
          storeEmail: this._userService.storeConfig.storeEmail,
          storePhone: this._userService.storeConfig.storePhone,
          storeName: this._userService.storeConfig.storeName,
        },
        environment.storeIdComplete
      )
      .subscribe({
        next: (response) => {
          this.progreesBarService.hideProgressBar();
          this.modalService.toggleModal(
            this.translate.instant('transversales.notification').toString().toUpperCase(),
            this.translate.instant('mcfLoginShell.passwordRecovery.successMessageEmail').toString(),
            true,
            'info'
          );
          this.router.navigate([ROUTER_LOGIN.LOGIN.FORM]);
        },
        error: (err) => {
          this.progreesBarService.hideProgressBar();
          this.modalService.toggleModal(
            this.translate.instant('transversales.notification').toString().toUpperCase(),
            this.translate.instant('mcfLoginShell.passwordRecovery.errorMessageEmail').toString(),
            true,
            'info'
          );
          this.router.navigate([ROUTER_LOGIN.LOGIN.FORM]);
        },
      });
  }

  public togglePassword(fieldId: string): void {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    if (field) {
      field.type = field.type === 'password' ? 'text' : 'password';
    }
  }
  public handleKeyUp(e: any): void {
    if (e.keyCode === 13) {
      // this.RecoverPassword();
    }
  }

  public RecoverPassword(){
    if (!this.passwordRecoveryForm.valid) {
      this.passwordRecoveryForm.markAllAsTouched();
      return;
    }
    this.allowSend = false;
    let replacePassword = this.passwordRecoveryForm.controls[
      'password'
    ].value.replace(/\s/g, '');

    this._passwordRecoveryService
      .PasswordRecovery(
        {
          NewPassWord: this.encrypt(replacePassword),
          storeEmail: this._userService.storeConfig.storeEmail,
          storePhone: this._userService.storeConfig.storePhone,
          storeId: environment.storeIdComplete,
          isRecovery:this.isRecovery
        },
        environment.storeIdComplete,
        this.passwordToken
      )
      .subscribe({
        next: (response) => {


          this.modalService.toggleModal(
            this.translate.instant('transversales.notification').toString().toUpperCase(),
            this.translate.instant('mcfLoginShell.passwordRecovery.changedPassword').toString(),
            true,
            'info'
          );
          this.router.navigate([ROUTER_LOGIN.LOGIN.FORM]);
        },
        error: (err) => {
          this.modalService.toggleModal(
            this.translate.instant('transversales.notification').toString().toUpperCase(),
            this.translate.instant('mcfLoginShell.passwordRecovery.errorChangePassword').toString(),
            true,
            'info'
          );
        },
      });
  }
  private encrypt(value: any): string {
    var key = CryptoJS.enc.Utf8.parse(environment.EncryptKey);
    var iv = CryptoJS.enc.Utf8.parse(environment.EncryptKey);
    var encrypted = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(value.toString()),
      key,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    return encrypted.toString();
  }

  private onChangeLanguage() {}
}
